import React from "react";

export const Container = ({ children, className = "" }) => <div className={`container ${className}`}>{children}</div>;

export const SectionTitle = ({ eyebrow, title, subtitle }) => (
    <div className="section-title">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h2 className="h2">{title}</h2>
        {subtitle && <p className="subtitle">{subtitle}</p>}
    </div>
);

export const Feature = ({ icon, title, desc }) => (
    <article className="card feature">
        <div className="feature-head">
            <div className="feature-icon" aria-hidden="true">{icon}</div>
            <h3 className="h3">{title}</h3>
        </div>
        <p className="muted">{desc}</p>
    </article>
);